import React from 'react';
import TenantMobileLayout from './TenantMobileLayout';
import GestioneBollePage from '../../pages/GestioneBollePage';

const TenantMobileBolle = ({ onBack, openNuovaBolla }) => {
  return (
    <TenantMobileLayout title="Gestione Bolle" onBack={onBack}>
      <div className="mobile-content-wrapper">
        <GestioneBollePage openNuovaBolla={openNuovaBolla} />
      </div>
    </TenantMobileLayout>
  );
};

export default TenantMobileBolle;
